export class user{
    id: string = '';
    name: string = '';
    imageUrl: string = '';
    last_seen: Date = new Date();
    email: string = '';
}